module.exports = __webpack_public_path__ + "img/promo-bg--991.da1a31d.webp";